module.exports = __webpack_public_path__ + "static/img/template-board-round.ed76dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/templates/template-board-round.png
// module id = 6k18
// module chunks = 1